export default __webpack_public_path__ + "static/media/entidadeIcon-grey.d3f9bd99.svg";